module.exports = __webpack_public_path__ + "img/yy-m1.410f8043.png";